const SCRIPT = 'script';
const LOAD = 'load';
const ERROR = 'error';
const SRC = 'src';

/**
 * CustomScriptLoader
 *
 * Append scripts dynamically into document.
 */
export class CustomScriptLoader {

    constructor() {
        this.map = new Map();
        this.body = document.body;
    }

    /**
     * @param scripts - Array of scripts to be appended to document body.
     */
    init(scripts = []) {
        if (!scripts.length) {
            return;
        }

        scripts.forEach((script) => {
            this.map.set(Object.keys(script)[0], Object.values(script)[0]);
        });
    }

    /**
     * @param script
     *
     * @returns string|undefined
     */
    getScript(script) {
        if (!this.map.has(script)) {
            return;
        }

        return this.map.get(script);
    }

    /**
     * @param targetedScript
     *
     * @returns boolean|undefined
     */
    isScriptAlreadyInDocument(targetedScript) {
        if (!targetedScript) {
            return;
        }

        const scripts = document.getElementsByTagName(SCRIPT);
        for (let i = scripts.length; i--;) {
            if (scripts[i].src === targetedScript) {
                return true;
            }
        }

        return false;
    }

    /**
     * @param script
     *
     * @returns Promise|undefined
     */
    appendScripts(script) {
        if (this.isScriptAlreadyInDocument(script) || !script) {
            return Promise.resolve();
        }

        if (Array.isArray(script)) {
            const scriptArray = [];
            script.forEach((subScript) => {
                if (!this.isScriptAlreadyInDocument(subScript)) {
                    scriptArray.push(this.appendScripts(subScript));
                }
            });

            return Promise.all(scriptArray);
        }


        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement(SCRIPT);
            scriptElement.setAttribute(SRC, script);
            scriptElement.addEventListener(LOAD, (event) => {
                resolve(event);
            });
            scriptElement.addEventListener(ERROR, (event) => {
                console.error(`Failed to load ${ script }`);
                reject(event);
            });
            scriptElement.async = false;
            scriptElement.defer = true;
            this.body.appendChild(scriptElement);
        });

    }

    /**
     * @param scripts
     */
    loadEssentialScripts(scripts = []) {
        if (!scripts.length) {
            return;
        }

        scripts.forEach((script) => {
            if (!this.isScriptAlreadyInDocument(script)) {
                this.appendScripts(script);
            }
        });
    }

    reset() {
        this.map.clear();
    }
}
